export default {"src":"/_next/static/media/edit.0e70dfd1.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};